import { FormattedMessage } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation, {
    ReturnToProduct
} from "@/components/signup/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    Headings,
    PickUpWhereYouLeftOffText,
    SubHeading,
    WelcomeBackHeading,
    WelcomeBackText
} from "../components";

export const CurrentProductUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <SignupBackgroundLayout
            ProductLogo={<ServiceCollectionLogo />}
            theme="yellow"
        >
            {team26VisualUpdates ? (
                <Headings
                    main={<WelcomeBackText />}
                    sub={<PickUpWhereYouLeftOffText />}
                />
            ) : (
                <>
                    <WelcomeBackHeading />
                    <SubHeading>
                        <FormattedMessage
                            id="return-to-product-modal.header.text"
                            defaultMessage="Pick up where you left off."
                        />
                    </SubHeading>
                </>
            )}
            {/* everyone with a service collection should see a return to product experience */}
            <SiteActivation CurrentProductUser={<ReturnToProduct />} />
        </SignupBackgroundLayout>
    );
};
